import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface StarsIconProps {
  color?: string;
  isActive?: boolean;
  size?: number;
  activeOnBlue?: boolean;
  filled?: boolean;
}

export default function StarsIcon({ color = '#A19F97', isActive = false, size = 24, activeOnBlue = false, filled = false }: StarsIconProps) {
  if (activeOnBlue) {
    return (
      <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <Path
          d="M13.3525 7.26367C14.0479 8.75371 15.2463 9.95211 16.7363 10.6475L19.6357 12L16.7363 13.3525C15.2463 14.0479 14.0479 15.2463 13.3525 16.7363L12 19.6357L10.6475 16.7363C9.95211 15.2463 8.75371 14.0479 7.26367 13.3525L4.36426 12L7.26367 10.6475C8.75371 9.95211 9.95211 8.75371 10.6475 7.26367L12 4.36426L13.3525 7.26367Z"
          fill="white"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Svg>
    );
  }

  if (isActive) {
    return (
      <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <Path 
          d="M13.3525 7.26367C14.0479 8.75371 15.2463 9.95211 16.7363 10.6475L19.6357 12L16.7363 13.3525C15.2463 14.0479 14.0479 15.2463 13.3525 16.7363L12 19.6357L10.6475 16.7363C9.95211 15.2463 8.75371 14.0479 7.26367 13.3525L4.36426 12L7.26367 10.6475C8.75371 9.95211 9.95211 8.75371 10.6475 7.26367L12 4.36426L13.3525 7.26367Z"
          fill="white"
          stroke="#151515"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Svg>
    );
  }

  if (filled) {
    return (
      <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <Path
          d="M13.3525 7.26367C14.0479 8.75371 15.2463 9.95211 16.7363 10.6475L19.6357 12L16.7363 13.3525C15.2463 14.0479 14.0479 15.2463 13.3525 16.7363L12 19.6357L10.6475 16.7363C9.95211 15.2463 8.75371 14.0479 7.26367 13.3525L4.36426 12L7.26367 10.6475C8.75371 9.95211 9.95211 8.75371 10.6475 7.26367L12 4.36426L13.3525 7.26367Z"
          fill={color}
          stroke={color}
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Svg>
    );
  }

  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path 
        d="M13.3525 7.26367C14.0479 8.75371 15.2463 9.95211 16.7363 10.6475L19.6357 12L16.7363 13.3525C15.2463 14.0479 14.0479 15.2463 13.3525 16.7363L12 19.6357L10.6475 16.7363C9.95211 15.2463 8.75371 14.0479 7.26367 13.3525L4.36426 12L7.26367 10.6475C8.75371 9.95211 9.95211 8.75371 10.6475 7.26367L12 4.36426L13.3525 7.26367Z"
        stroke={color} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </Svg>
  );
}
